import { asyncComponent, retryImport } from '@ohif/ui';
import OHIF from '@ohif/core';
import { UnauthorizedLayout } from '../AZmed/Layouts/UnauthorizedLayout.js';
import { IS_OFFLINE_BUILD } from '../AZmed/Config/buildMode';

const { urlUtil: UrlUtil } = OHIF.utils;

// Dynamic Import Routes (CodeSplitting)
const ViewerRouting = asyncComponent(() =>
  retryImport(() =>
    import(/* webpackChunkName: "ViewerRouting" */ './ViewerRouting.js')
  )
);

const StudyListRouting = asyncComponent(() =>
  retryImport(() =>
    import(
      /* webpackChunkName: "StudyListRouting" */ '../studylist/StudyListRouting.js'
    )
  )
);

const ViewerLocalFileData = asyncComponent(() =>
  retryImport(() =>
    import(
      /* webpackChunkName: "ViewerLocalFileData" */ '../connectedComponents/ViewerLocalFileDataStudyProps.js'
    )
  )
);

const ROUTES_DEF = {
  default: {
    viewer: {
      path: '/viewer/:studyInstanceUIDs',
      component: ViewerRouting,
    },
    list: {
      path: '/',
      component: StudyListRouting,
      condition: appConfig => {
        return appConfig.showStudyList;
      },
    },
    local: {
      path: '/local',
      component: ViewerLocalFileData,
    },
    unauthorized: {
      path: '/unauthorized',
      component: UnauthorizedLayout,
      // No authentication offline, hence nothing to be unauthorized for
      condition: () => !IS_OFFLINE_BUILD,
    },
  },
};

// Build the list of routes enabled for the given app configuration
const getRoutes = appConfig => {
  const routes = [];

  for (let keyConfig in ROUTES_DEF) {
    const routesConfig = ROUTES_DEF[keyConfig];

    for (let routeKey in routesConfig) {
      const route = routesConfig[routeKey];
      const validRoute =
        typeof route.condition === 'function'
          ? route.condition(appConfig)
          : true;

      if (validRoute) {
        routes.push({
          path: route.path,
          Component: route.component,
        });
      }
    }
  }

  return routes;
};

// Replace the path params with the server and params values
const parsePath = (path, server, params) => {
  let _path = path;
  const _paramsCopy = Object.assign({}, server, params);

  for (let key in _paramsCopy) {
    _path = UrlUtil.paramString.replaceParam(_path, key, _paramsCopy[key]);
  }

  return _path;
};

// Build the viewer path for the given server and params
const parseViewerPath = (server = {}, params) =>
  parsePath(ROUTES_DEF.default.viewer.path, server, params);

export { getRoutes, parseViewerPath };
